var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.39743 1.07595C7.38345 0.751362 7.22635 0.487679 6.80916 0.487684C6.39197 0.487689 6.1937 0.800265 6.22094 1.07595C6.24817 1.35164 6.22094 5.74019 6.22094 5.74019C6.22094 5.74019 2.01149 5.70155 1.5567 5.74018C1.44563 5.74962 0.968927 5.8202 0.968712 6.32818C0.968498 6.83616 1.4942 6.91106 1.5567 6.91667C2.01104 6.95746 6.22094 6.91668 6.22094 6.91668C6.22094 6.91668 6.18085 10.7094 6.22094 11.5809C6.23196 11.8205 6.39188 12.1693 6.80919 12.1692C7.22649 12.169 7.38743 11.8117 7.39743 11.5809C7.43523 10.7087 7.39743 6.91668 7.39743 6.91668C7.39743 6.91668 11.7675 6.92934 12.0617 6.91668C12.2577 6.90824 12.6499 6.81817 12.6499 6.32843C12.6499 5.8387 12.2041 5.75195 12.0617 5.74019C11.6069 5.70264 7.39743 5.74019 7.39743 5.74019C7.39743 5.74019 7.43498 1.94789 7.39743 1.07595Z",
    fill: "#C84747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.e56a03a3.svg";
export { ForwardRef as ReactComponent };